define("SDB.Locations.Finance.Modal.View", [
  "sdb_no_selected_location.tpl",
  "SCView",
], function (no_selected_location_tpl, SCViewComponent) {
  "use strict";

  var SCView = SCViewComponent.SCView;

  function SDBLocationsFinanceModalView(options) {
    SCView.call(this);

    this.options = options;
    this.template = no_selected_location_tpl;
    this.page_header = this.options.pageHeader || this.getTitle();
    this.view = this.options.view;
    this.modalClass = "sdb-locations-finance-modal-view";

    this.events = {
      'click [data-action="close-message"]': "closeModal",
    };

    this.listenTo(this, "all", function (eventName) {
      eventName == "modal-close" && this.closeModal();
    });

    this.on("destroy", this.closeModal.bind(this));
  }

  SDBLocationsFinanceModalView.prototype = Object.create(SCView.prototype);
  SDBLocationsFinanceModalView.prototype.constructor =
    SDBLocationsFinanceModalView;

  SDBLocationsFinanceModalView.prototype.closeModal = function () {
    Backbone.history.navigate("/", { trigger: true });
    this.options.container.getLayout()
      ? this.options.container.getLayout().closeModal()
      : null;
    $("body").removeClass("modal-open");
    $(".modal-backdrop").remove();
  };

  SDBLocationsFinanceModalView.prototype.getContext = function () {
    return {
      message: "Sorry, we do not offer financing for online shopping yet.",
      title: "SHOPPING EXPERIENCE NOT SUPPORTED",
      showContent: this.options.showContent,
    };
  };

  return SDBLocationsFinanceModalView;
});
